// React Imports
import * as React from 'react';
import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import {
    Select
} from "@mui/material";

// App Imports

import DashboardPivot from "./DashboardPivot";
import {changeWork} from "../../Work/workSlice";
import {changeContractDrilldownExpandCS} from "../../ContractDrilldown/contractDrilldownSliceExpandCS";



// Main Function
export default function DashboardPivotDrawer() {


    // ****************** BEGIN STATES ****************************

    const [showContractDataPointValueDrawer, setShowContractDataPointValueDrawer] = React.useState(false);
    const [submitting, setSubmitting] = useState(true);
    const [dashboardFormState, setDashboardFormState] = useState(false);
    const [dashboardExpression, setDashboardExpression] = useState([useSelector((state) => state.contractDataPointValueSlc.value.expression)]);

    // ****************** END STATES ****************************


    // ****************** BEGIN STORE ****************************

    const dispatchData = useDispatch() ;
    const selectorContractDataPointValueId = useSelector((state) => state.contractDataPointValueSlc.value.id);
    const selectorContractDataPointId = useSelector((state) => state.contractDataPointSlc.value.id);
    // const selectorDashboardDrawerState = useSelector((state) => state.contractDataPointValueSlc.value.dashboardDrawerState);
    // const selectorDashboardFormState = useSelector((state) => state.contractDataPointValueSlc.value.dashboardFormState);
    // const selectorDashboardDrawerMode = useSelector((state) => state.contractDataPointValueSlc.value.dashboardDrawerMode);

    const selectorDashboardPivotState = useSelector((state) => state.workSlc.value.dashboardPivotState);

    // ****************** END STORE ****************************


    // ****************** BEGIN REGISTER ****************************


    // ****************** END REGISTER ****************************



    // new ChatGpt version
    const openSourceWindow = (sourceRow) => {
        // 1. Build the child URL from wherever we are right now
        const childURL   = `${window.location.origin}/Work`;
        const childOrigin = new URL(childURL).origin;        // no path, no trailing slash

        console.log("Opening child window at:", childURL);
        console.log("Data available to send to child window:");
        console.log(sourceRow["System Contract ID"]);

        // 2. Open the window
        // const newWindow = window.open(childURL, "_blank", "noopener");
        const newWindow = window.open(childURL, "_blank");



        // 3. Local UI update
        // dispatchData(changeContractDrilldownExpandCS({ focusCdpId: sourceRow.id }));

        // 4. Prepare exactly your original payload
        const dataToSend = {
            type: "UPDATE_DATA",
            payload: {
                contractId:          sourceRow["System Contract ID"],
                versionNumber:        sourceRow.versionNumber
            },
        };

        // const sendMessage = (tag) => {
        //     console.log(">>> sendMessage()", tag, "at", Date.now());
        //     if (newWindow && !newWindow.closed) {
        //         try {
        //             newWindow.postMessage(dataToSend, childOrigin);
        //             console.log("Sent payload to child:", dataToSend);
        //         } catch (err) {
        //             console.error("postMessage failed:", err);
        //         }
        //     }
        // };
        const sendMessage = (tag) => {
            const now = new Date().toLocaleTimeString();
            console.log(`>>> sendMessage(${tag}) at ${now}`);

            if (!newWindow || newWindow.closed) {
                console.warn("newWindow closed or missing");
                return;
            }

            try {
                newWindow.postMessage(dataToSend, childOrigin);
                console.log("✓ Sent payload to child (", tag, ")");
            } catch (err) {
                console.error("✗ postMessage failed (", tag, "):", err);
            }
        };
        // a) try right away (cached fast loads)
        sendMessage("immediate");
        // console.log(">>> sendMessage() called at", Date.now());
        // b) as soon as the document is fully loaded
        // newWindow?.addEventListener("load", sendMessage, { once: true });
        if (newWindow && typeof newWindow.addEventListener === "function") {
            // `{ once: true }` is fine in all modern browsers; remove it for IE11
            newWindow.addEventListener("load", () => sendMessage("load"), { once: true });
        }
        // c) fallback after 5 s if neither of the above hit
        setTimeout(() => sendMessage("timeout"), 5000);
    };



    // *********************** BEGIN DROPDOWNS **************************


// *********************** END DROPDOWNS **************************


    // ****************** BEGIN MISC ****************************


    const closeDashboardPivotDrawer = () => {
        dispatchData(changeWork({dashboardPivotState: false, dashboardVersionId: null}));
    };

    // ****************** END MISC ****************************



    // ****************** BEGIN RETURN ****************************

    return (
        <div>

            <Drawer
                sx={{ width: '1500px' }}
                anchor='right'
                // open={true}
                // initialState={{open: true}}
                open={selectorDashboardPivotState}
                initialState={{open: false}}
                onClose={closeDashboardPivotDrawer}
            >
                <DashboardPivot
                    closeDashboardPivotDrawer={closeDashboardPivotDrawer}
                    openSourceWindow={openSourceWindow}
                />

            </Drawer>
        </div>
    );

    // ****************** END RETURN ****************************

}
